import { serviceURL } from "../../../utils/service-url";

import type { TemplateSearchResult } from "../types";
import type { AtlasDiscoverRow } from "./supabase-atlas-service";

export async function atlasV2Search(
  q: string,
  token: string,
  unstable?: boolean,
): Promise<TemplateSearchResult[]> {
  const params = new URLSearchParams();
  params.append("q", q);
  params.append("count", "30");
  if (unstable) params.append("unstable", "1");

  const resp = await fetch(`${serviceURL("atlas-v2")}discover/search?${params.toString()}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!resp.ok) throw new Error("Failed to search templates");

  const data: {
    results: { metadata: NonNullable<AtlasDiscoverRow["metadata"]> }[];
  } = await resp.json();

  return data.results
    .filter((d) => !d.metadata.sequence)
    .map((d) => ({
      slug: d.metadata.template.data.data.slug,
      program: d.metadata.program.data.slug,
    }));
}
